// Module
var code = "<component :is=\"tag\" :tabindex=\"disabled ? -1 : 0\" @keydown=\"onKeyEvent\" @click.stop.prevent=\"$emit('click')\" :aria-label=\"disabled ? '' : 'Use up and down keys to reorder'\" :class=\"className\"> <slot></slot> <span v-if=\"!disabled\" aria-live=\"polite\" class=\"assistive-text\"> {{ assistiveText }} </span> </component> ";
// Exports
export default code;